import { BillType } from "./bill";

export enum TABLE_STATUS {
  FREE = 'FREE',
  OCCUPIED = 'OCCUPIED',
  RESERVED = 'RESERVED',
}

export interface ITables {
  _id?: string;
  tableNo: number;
  tableName: string;
  floorNo: number;
  place: string;
  capacity: number;
  xAxis: number;
  yAxis: number;
  width: number;
  height: number;
  rotation: number;
  placeId: string;
  floorId: string;
  isActive: boolean;
  tableIcon: string;
  tableImage: string;
  tableColor: string;
  chairColor: string;
  status: TABLE_STATUS;
  tableType: "CIRCULAR" | "SQUARE" | "RECTANGULAR" | "DEFAULT";
  billSession: BillType | null;
}

export interface IClientTableManager {
  tables: {[key:string] : ITables}
  places: Array<string> // eg: INDOOR, OUTDOOR, POOL_VIEW
  noOffloors: number
}
